import React, { useMemo, useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { TagModalsProvider } from './TagModalsManagerContext'
import { TagsBoardContent } from './TagsBoardContent'
import { DEVICE_TYPES } from 'constants/UI'
import useWindowDimensions from 'hooks/useWindowDimensions'

const TagsBoard: React.FC = () => {
  const { tags } = useSelector((state: RootState) => state.config.config)
  const { windowWidth } = useWindowDimensions()

  const [searchQuery, setSearchQuery] = useState('')
  const [loadingTags] = useState<Record<string, boolean>>({})
  const [viewMode, setViewMode] = useState<'grid' | 'table'>('table')

  const tagsList = useMemo(() => {
    return tags.filter((tag) => tag.name.toLowerCase().includes(searchQuery.toLowerCase()))
  }, [tags, searchQuery])

  useEffect(() => {
    if (DEVICE_TYPES.MOBILE(windowWidth)) {
      setViewMode('grid')
    }
  }, [windowWidth])

  return (
    <TagModalsProvider>
      <TagsBoardContent
        tags={tagsList}
        viewMode={viewMode}
        onChangeViewMode={() => setViewMode(viewMode === 'grid' ? 'table' : 'grid')}
        searchQuery={searchQuery}
        onSearch={setSearchQuery}
        loadingTags={loadingTags}
      />
    </TagModalsProvider>
  )
}

export default TagsBoard
